import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import PinnedLayers from '../modules/pinned-layers.js'

//

//
export default class extends Component {
	prepare() {
		// prepare pinned layers
		this.layers = this.element.querySelectorAll('[data-layer]')
		this.pinnedLayers = new PinnedLayers({ layers: this.layers })
		this.pinnedLayers.init()

		this.bndOnContentReplace = this.onContentReplace.bind(this)
		EventBus.on('swup:content:replace', this.bndOnContentReplace)

		// this.bndHandleHash = this.handleHash.bind(this)
		// window.addEventListener('hashchange', this.bndHandleHash)
	}

	mount() {}

	unmount() {
		console.log('body component unmounted')
		if (this.pinnedLayers) {
			this.pinnedLayers.destroy() // Assuming you have a destroy method to clean up ScrollTriggers
		}
	}

	onContentReplace() {
		console.log('Content replaced, re-initializing pinned layers')
		// re-initialize pinned layers after content replacement
		this.layers = this.element.querySelectorAll('[data-layer]')
		this.pinnedLayers = new PinnedLayers({ layers: this.layers })
		this.pinnedLayers.init()
	}
}
